export function useColor(color) {
    var type = color === 'white' || color === 'black' || color === 'theme' ? color : 'custom';
    return {
        type: type,
        color: type === 'custom' ? color : undefined,
    };
}
